import { render, staticRenderFns } from "./InputDialog.vue?vue&type=template&id=b63d3b3c&scoped=true"
import script from "./InputDialog.vue?vue&type=script&lang=js"
export * from "./InputDialog.vue?vue&type=script&lang=js"
import style0 from "./InputDialog.vue?vue&type=style&index=0&id=b63d3b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63d3b3c",
  null
  
)

export default component.exports